import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchAddresses as fetchAddressesService,
  fetchAddressById as fetchAddressByIdService,
  createAddress as createAddressService,
  updateAddress as updateAddressService,
  deleteAddress as deleteAddressService,
  queryTaxNumber as queryTaxNumberService,
} from "./address.service";
import {
  Address,
  CreateAddressRequest,
  UpdateAddressRequest,
  TaxQueryData,
} from "./address.types";
import { ApiResponse } from "../../api/api.types";
import { handleApiError } from "@/app/utils/handleApiError";

export const getAddresses = createAsyncThunk<
  ApiResponse<{ items: Address[] }>,
  void,
  { rejectValue: string }
>("address/getAddresses", async (_, { rejectWithValue }) => {
  try {
    const response = await fetchAddressesService();
    return response;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const getAddressById = createAsyncThunk<
  ApiResponse<Address>,
  number,
  { rejectValue: string }
>("address/getAddressById", async (id, { rejectWithValue }) => {
  try {
    const response = await fetchAddressByIdService(id);
    return response;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const createAddress = createAsyncThunk<
  ApiResponse<[]>,
  CreateAddressRequest,
  { rejectValue: string }
>("address/createAddress", async (data, { rejectWithValue }) => {
  try {
    const response = await createAddressService(data);
    return response;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const updateAddress = createAsyncThunk<
  ApiResponse<[]>,
  { id: number; data: UpdateAddressRequest },
  { rejectValue: string }
>("address/updateAddress", async ({ id, data }, { rejectWithValue }) => {
  try {
    const response = await updateAddressService(id, data);
    return response;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const deleteAddress = createAsyncThunk<
  ApiResponse<[]>,
  number,
  { rejectValue: string }
>("address/deleteAddress", async (id, { rejectWithValue }) => {
  try {
    const response = await deleteAddressService(id);
    return response;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const setDefaultAddress = createAsyncThunk<
  ApiResponse<[]>,
  number,
  { rejectValue: string }
>("address/setDefaultAddress", async (id, { rejectWithValue }) => {
  try {
    const response = await updateAddressService(id, {
      is_default: true,
    } as UpdateAddressRequest);
    return response;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const queryTaxNumber = createAsyncThunk<
  TaxQueryData,
  string,
  { rejectValue: string }
>("address/queryTaxNumber", async (taxNumber, { rejectWithValue }) => {
  try {
    const response = await queryTaxNumberService(taxNumber);
    return response.data as TaxQueryData;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});
